import { Expose } from 'class-transformer';

export default class MatchedJobFormError {
    practice_id: string[] = []
    nurse_id: string[] = []
    date: string[] = []
    start_time: string[] = []
    end_time: string[] = []
    lunch_break: string[] = []
    description: string[] = []
    hygienist_required: string[] = []
    sedation_required: string[] = []
    radiography_required: string[] = []
    implant_required: string[] = []
    orthodontics_required: string[] = []
    parking: string[] = []
    @Expose({ name: '_schema' }) schema: string[] = []
}